/* Dead Good theme — interactivity. Mirrors the React landing page behaviour. */
(function () {
  'use strict';

  // ---- tracking (respects the ?notrack / /test kill-switch; never sends PII) ----
  var GA4_EVENT = { AddToCart: 'add_to_cart', InitiateCheckout: 'begin_checkout', Lead: 'generate_lead' };
  function track(event, data) {
    data = data || {};
    if (window.__NOTRACK__) return;
    try {
      var safe = {};
      for (var k in data) { if (k !== 'email') safe[k] = data[k]; }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, safe));
      if (typeof window.fbq === 'function') window.fbq('track', event, safe);
      if (typeof window.gtag === 'function') window.gtag('event', GA4_EVENT[event] || event, safe);
    } catch (e) {}
  }
  window.dgTrack = track;

  // ---- cart drawer ----
  var drawer = document.getElementById('dg-cart');
  var overlay = drawer && drawer.querySelector('[data-cart-overlay]');
  var panel = drawer && drawer.querySelector('[data-cart-panel]');
  var itemsEl = drawer && drawer.querySelector('[data-cart-items]');
  var footerEl = drawer && drawer.querySelector('[data-cart-footer]');
  var payEl = drawer && drawer.querySelector('[data-cart-pay]');
  var expressEl = drawer && drawer.querySelector('[data-cart-express]');
  var countEl = drawer && drawer.querySelector('[data-cart-count]');
  var bubbleEl = document.querySelector('[data-cart-bubble]'); // header cart count

  function setBubble(count) {
    if (!bubbleEl) return;
    bubbleEl.textContent = count;
    bubbleEl.classList.toggle('hidden', count === 0);
  }

  function money(cents) { return '£' + (cents / 100).toFixed(2); }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.remove('hidden');
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { overlay.style.opacity = '1'; panel.style.transform = 'translateX(0)'; });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    overlay.style.opacity = '0';
    panel.style.transform = 'translateX(100%)';
    document.body.style.overflow = '';
    setTimeout(function () { drawer.classList.add('hidden'); drawer.setAttribute('aria-hidden', 'true'); }, 300);
  }

  function tickRow(label) {
    return '<li class="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wide text-paper">'
      + '<span class="w-4 h-4 rounded-full text-ink flex items-center justify-center" style="background-color:#21E6FF;"><svg viewBox="0 0 24 24" fill="none" class="w-3 h-3"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>'
      + label + '</li>';
  }

  function renderCart(cart) {
    if (!drawer) return;
    countEl.textContent = '(' + cart.item_count + ')';
    setBubble(cart.item_count);
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="text-paper font-medium py-10 text-center">Your cart&rsquo;s empty.</p>';
      footerEl.innerHTML = '';
      if (payEl) payEl.classList.add('hidden');
      if (expressEl) expressEl.classList.add('hidden');
      return;
    }
    if (payEl) payEl.classList.remove('hidden');
    if (expressEl) expressEl.classList.remove('hidden');

    var freeShip = '<div class="rounded-xl px-4 py-2.5 mb-3 text-center" style="background-color:#CDFF00;"><span class="font-mono text-[11px] font-black uppercase tracking-wide text-ink">Congrats! You&rsquo;ve unlocked FREE SHIPPING</span></div>';
    var launch = '<div class="rounded-xl border border-white/15 bg-white/[0.04] px-4 py-2.5 mb-4 text-center leading-snug"><span class="font-mono text-[10px] font-black uppercase tracking-widest" style="color:#FF2EA6;">Launch price</span> <span class="font-mono text-[10px] font-black uppercase tracking-widest text-paper">32% off &middot; first batch only</span></div>';
    var trust = '<ul class="flex flex-wrap justify-center gap-x-5 gap-y-2 mt-5 pt-5 border-t border-white/10">' + tickRow('Free UK shipping') + tickRow('30-day money-back') + '</ul>';

    var items = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" alt="" class="w-16 h-16 rounded-xl object-cover border border-white/15">' : '';
      var price = it.original_line_price !== it.final_line_price
        ? '<span class="font-mono text-sm text-paper line-through">' + money(it.original_line_price) + '</span><div class="font-display text-acid text-xl">' + money(it.final_line_price) + '</div>'
        : '<span class="font-display text-paper text-xl">' + money(it.final_line_price) + '</span>';
      var variant = it.variant_title && it.variant_title.indexOf('Default') < 0
        ? '<div class="font-mono text-[11px] uppercase tracking-wide text-paper mt-0.5">' + it.variant_title + '</div>' : '';
      return '<div class="rounded-[18px] border-2 border-white/12 bg-white/[0.03] p-4 flex gap-3 mb-3">'
        + '<div class="shrink-0">' + img + '</div>'
        + '<div class="min-w-0 flex-1">'
        +   '<div class="font-black tighter leading-tight">' + it.product_title + '</div>' + variant
        +   '<div class="mt-2 flex items-center gap-2">'
        +     '<div class="flex items-center border-2 border-white/20 rounded-full overflow-hidden">'
        +       '<button type="button" data-cart-change data-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '" class="px-2.5 py-1 text-paper hover:text-acid leading-none" aria-label="Decrease">&minus;</button>'
        +       '<span class="w-8 text-center text-paper font-bold text-sm">' + it.quantity + '</span>'
        +       '<button type="button" data-cart-change data-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" class="px-2.5 py-1 text-paper hover:text-acid leading-none" aria-label="Increase">+</button>'
        +     '</div>'
        +     '<button type="button" data-cart-change data-key="' + it.key + '" data-qty="0" class="font-mono text-[10px] uppercase tracking-wide text-paper hover:text-[#ff6a6a]">Remove</button>'
        +   '</div>'
        + '</div>'
        + '<div class="text-right shrink-0">' + price + '</div>'
        + '</div>';
    }).join('');
    itemsEl.innerHTML = freeShip + launch + items + trust;

    var savings = cart.total_discount > 0
      ? '<div class="flex justify-between font-mono text-[12px] uppercase tracking-widest text-acid mb-3"><span>You save</span><span>&minus;' + money(cart.total_discount) + '</span></div>' : '';
    footerEl.innerHTML = savings
      + '<div class="flex items-baseline justify-between mb-3"><span class="font-mono text-[11px] uppercase tracking-widest text-paper">Subtotal</span><span class="font-display text-2xl text-acid rave-tglow-acid">' + money(cart.total_price) + '</span></div>'
      + '<button type="button" data-cart-checkout data-total="' + (cart.total_price / 100) + '" class="w-full rounded-full py-4 font-black uppercase tracking-wide text-ink rave-box-acid hover:scale-[1.01] transition-transform" style="background-color:#CDFF00;">Checkout securely &rarr;</button>'
      + '<p class="mt-2 font-mono text-[10px] uppercase tracking-wide text-paper text-center">Shipping&rsquo;s on us &middot; taxes shown at checkout</p>';
  }

  function refreshCart(open) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openDrawer(); })
      .catch(function () {});
  }

  function changeCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  // ---- add to cart -> open the drawer ----
  function addToCart(variantId, btn) {
    if (!variantId) { console.warn('[Dead Good] No offer product set in theme settings.'); return; }
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    track('AddToCart', { content_name: 'DEAD GOOD LAUNCH', value: 16.99, currency: 'GBP' });
    // Add a single pack — the launch price comes from the product's price + compare-at (no discount logic).
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = original; }
        if (!res.ok) { console.warn('[Dead Good] add to cart failed', res.body); return; }
        // Open the slide-in cart so the customer can review/edit before checking out.
        refreshCart(true);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  }

  // ---- delegated clicks ----
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add-to-cart]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-variant-id'), add); return; }

    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(true); return; }

    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { closeDrawer(); return; }

    var change = e.target.closest('[data-cart-change]');
    if (change) { changeCart(change.getAttribute('data-key'), parseInt(change.getAttribute('data-qty'), 10)); return; }

    var co = e.target.closest('[data-cart-checkout]') || e.target.closest('[data-checkout]');
    if (co) { track('InitiateCheckout', { value: parseFloat(co.getAttribute('data-total') || co.getAttribute('data-cart-total')) || undefined, currency: 'GBP' }); if (co.hasAttribute('data-cart-checkout')) window.location.href = '/checkout'; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // prime the drawer contents on load (so re-opening is instant)
  if (drawer) refreshCart(false);

  // ---- sticky CTA: reveal after scrolling past the hero ----
  var sticky = document.getElementById('dg-sticky');
  if (sticky) {
    var raf = null;
    var onScroll = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        sticky.style.transform = (window.scrollY || 0) > 560 ? 'translateY(0)' : 'translateY(120%)';
        raf = null;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- product gallery: thumbnail -> swap main image ----
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var mains = gal.querySelectorAll('[data-gallery-img]');
    var thumbs = gal.querySelectorAll('[data-gallery-thumb]');
    function show(i) {
      mains.forEach(function (m) { m.style.opacity = +m.dataset.i === i ? '1' : '0'; });
      thumbs.forEach(function (t) {
        var on = +t.dataset.i === i;
        t.style.borderColor = on ? '#CDFF00' : 'rgba(255,255,255,0.14)';
        t.style.boxShadow = on ? '0 0 12px #CDFF0055' : 'none';
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
  });

  // ---- occasions: tabs + auto-rotate ----
  document.querySelectorAll('[data-occasions]').forEach(function (sec) {
    var imgs = sec.querySelectorAll('[data-occasion-img]');
    var tabs = sec.querySelectorAll('[data-occasion-tab]');
    var word = sec.querySelector('[data-occasion-word]');
    var caption = sec.querySelector('[data-occasion-caption]');
    var labels = Array.prototype.map.call(tabs, function (t) { return t.textContent.trim(); });
    var n = imgs.length, cur = 0;
    function show(i) {
      cur = i;
      imgs.forEach(function (m) { m.style.opacity = +m.dataset.i === i ? '1' : '0'; });
      tabs.forEach(function (t) {
        var on = +t.dataset.i === i;
        t.style.borderColor = on ? '#21E6FF' : 'rgba(247,244,241,0.18)';
        t.style.color = on ? '#21E6FF' : '#F7F4F1';
      });
      if (word) { word.textContent = labels[i] + '.'; word.classList.remove('animate-word'); void word.offsetWidth; word.classList.add('animate-word'); }
      if (caption) caption.textContent = labels[i];
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
    if (n > 1) setInterval(function () { show((cur + 1) % n); }, 2200);
  });
})();
